export const LEGACY_TARGET_MAP = Object.freeze({
  '/pages/mine/about': '/pages/article/list?code=about',
  '/pages/mine/activities': '/pages/activity/index',
})

export const TARGET_LABEL_FALLBACK = Object.freeze({
  '/pages/index/index': '首页',
  '/pages/article/list?code=about': '关于我们（三栏）',
  '/pages/article/list?code=meeting': '专业会议（三栏）',
  '/pages/article/list?code=award': '表彰公示',
  '/pages/join/form': '入会申请',
  '/pages/activity/index': '活动列表',
  '/pages/map/index': '人脉地图',
  '/pages/supply/plaza': '供需广场',
  '/pages/mine/index': '我的',
})

/** 公众号推文链接（与小程序 openOfficialAccountArticle 一致） */
export function isWechatArticleUrl(url) {
  return /^https?:\/\/mp\.weixin\.qq\.com\//i.test(String(url || '').trim())
}

/** 轮播跳转种类：PAGE 站内页 / WECHAT 公众号文章 */
export function inferBannerLinkKind(linkTarget) {
  return isWechatArticleUrl(linkTarget) ? 'WECHAT' : 'PAGE'
}

export function normalizeTargetValue(raw) {
  const v = String(raw || '').trim()
  if (!v) return ''
  if (isWechatArticleUrl(v)) return v
  return LEGACY_TARGET_MAP[v] || v
}

export function fallbackLabelByValue(value) {
  const v = String(value || '').trim()
  if (!v) return ''
  if (isWechatArticleUrl(v)) return '公众号文章'
  return TARGET_LABEL_FALLBACK[v] || ''
}

export function createEmptyBannerForm() {
  return {
    title: '',
    imageUrl: '',
    pageTargetId: null,
    linkTarget: '',
    linkKind: 'PAGE',
    sortOrder: 0,
    statusCode: 'ENABLED',
    remark: '',
  }
}

export function mapPageTargetRows(rows) {
  const mapped = Array.isArray(rows)
    ? rows
        .map((r) => {
          const rawValue = String(r?.targetValue || '').trim()
          const value = normalizeTargetValue(rawValue)
          const rawLabel = String(r?.targetLabel || '').trim()
          const label =
            rawValue === '/pages/mine/about'
              ? '关于我们（三栏）'
              : rawLabel || fallbackLabelByValue(value) || fallbackLabelByValue(rawValue) || '未知页面'
          return {
            id: r?.id != null ? Number(r.id) : r?.targetId != null ? Number(r.targetId) : null,
            value,
            label,
          }
        })
        .filter((x) => x.value)
    : []
  const seen = new Set()
  const deduped = mapped.filter((x) => {
    if (seen.has(x.value)) return false
    seen.add(x.value)
    return true
  })
  const mustHave = [{ value: '/pages/article/list?code=about', label: '关于我们（三栏）' }]
  for (const it of mustHave) {
    if (!seen.has(it.value)) {
      deduped.unshift({ id: null, value: it.value, label: it.label })
      seen.add(it.value)
    }
  }
  return deduped
}
